import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {LoyaltyCardSearchModel} from "../loyalty-card-search-model.service";
import {LoyaltyCardEntityModel} from "../loyalty-card-entity-model.service";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-loyalty-card-search-page",
    templateUrl: "./loyalty-card-search-page.component.html",
    providers: [provideSearchModel(LoyaltyCardSearchModel), provideEntityModel(LoyaltyCardEntityModel)]
})
export class LoyaltyCardSearchPageComponent extends AbstractSearchPage {
}
